import { useState } from 'react'
import DatePicker from 'react-datepicker'
import { FaTimes } from 'react-icons/fa'
import { format, parse } from 'date-fns'

const getDate = value => value ? new Date(value) : null
const dateFormat = 'MM/dd/yyyy'

const BaseDatePicker = (
    props
) => {
    const [value, setValue] = useState(!props.currentValue ? null : parse(props.currentValue, dateFormat, new Date()))
    return (
        <div 
            className={`dateSelectorWrapper control has-icons-right`}
            style={{ ...props.wrapperStyle, }}
        >
            <DatePicker
                portalId={'react-dateselect'}
                className={`input is-normal`}
                // maxDate={new Date()}
                dateFormat={dateFormat}
                showYearDropdown
                showMonthDropdown
                yearDropdownItemNumber={150}
                scrollableYearDropdown
                autoComplete="off"
                selected={value}
                onChange={e => {
                    if(props.handleOnChange) {
                        props.handleOnChange(e)
                    }
                    setValue(e)
                    return e
                }}
                {...props}
            />
            <span
                className="icon is-right"
                onClick={() => {
                    props.handleOnChange(null)
                    setValue(null)
                }}
            >
                <FaTimes />
            </span>
        </div>
    )
}


export default BaseDatePicker